(function() {
  $(document).ready(function () {
    updateProgressBar();
    updateFrequency();
    updatePrice();
    updateTierPrices();
    updateAddToCart();
  });

  // --- Reset bundle builder (fired when cart drawer closes) ---
  document.addEventListener('bundle:reset', function() {
    updateProgressBar();
    updateFrequency();
    updatePrice();
    updateAddToCart();
  });

  // --- Subscription frequency change ---
  $(document).delegate('#smartrr-plans-frequency-select', 'change', function () {
    var dataAttrs = $(this).find('option:selected').data();
    $('.bundle-product-list-items .bundle-product-list-item').each(function() {
      $(this).attr('data-selling-plan-id', dataAttrs.sellingPlanId);
    });
    updatePrice();
    updateAddToCart();
  });

  // --- Add flavor ---
  $(document).delegate(".bundle-quantity-container .bundle-add-btn.is-active", "click", function() {
    $(this).removeClass('is-active');
    $(this).next('.bundle-quantity-box').addClass('is-active');
    $(this).parents('.bundle-product-list-item').addClass('item-active');
    var qtyDisplay = $(this).parents('.bundle-quantity-container').find('.bundle-qty-display');
    qtyDisplay.text(1);
    updateProgressBar();
    updateFrequency();
    updatePrice();
    updateAddToCart();
  });

  // --- Quantity plus ---
  $(document).delegate(".bundle-quantity-container .qty-button-plus", "click", function() {
    qtyPlusMinus($(this));
  });

  // --- Quantity minus ---
  $(document).delegate(".bundle-quantity-container .qty-button-minus", "click", function() {
    qtyPlusMinus($(this), -1);
  });

  function qtyPlusMinus(ele, qty) {
    if (typeof qty === 'undefined') qty = 1;
    var qtyDisplay = ele.parents('.bundle-quantity-box').find('.bundle-qty-display');
    var current = parseInt(qtyDisplay.text());

    if (qty === 1) {
      qtyDisplay.text(current + 1);
    } else if (current > 1) {
      qtyDisplay.text(current - 1);
    } else {
      qtyDisplay.text(0);
      ele.parents('.bundle-quantity-box').removeClass('is-active');
      ele.parents('.bundle-product-list-item').removeClass('item-active');
      ele.parents('.bundle-quantity-container').find('.bundle-add-btn').addClass('is-active');
    }

    updateProgressBar();
    updateFrequency();
    updatePrice();
    updateAddToCart();
  }

  // --- Purchase option toggle ---
  $(document).delegate("input[data-smartrr-selling-plan-group-input]", "change", function () {
    updatePrice();
    updateTierPrices();
    updateAddToCart();
  });

  // --- Tag cart with bundle source so Shopify Flow can apply customer tag ---
  function setBundleSourceAttribute(callback) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { source: 'organic-offer-bundle' } })
    })
      .then(function() { if (callback) callback(); })
      .catch(function(err) {
        console.error('Bundle source attribute error:', err);
        if (callback) callback();
      });
  }

  // --- Subscribe button ---
  $(document).delegate("#bundle_buy_button", "click", function(e) {
    e.preventDefault();
    if (!$(this).prop('disabled')) {
      var btn = $(this);
      btn.attr('disabled', 'disabled').addClass('disabled');
      btn.find('.loading__spinner').removeClass('hidden');
      var has_subscription = $('.bundle-product-purchase-options .smartrr-otp.smartrr-group-inactive').length;
      var items = [];
      $('.bundle-product-list-items .bundle-product-list-item.item-active:not([data-sold-out])').each(function() {
        var item = {
          id: $(this).attr('data-variant-id'),
          quantity: parseInt($(this).find('.bundle-qty-display').text())
        };
        var isPreOrder = $(this).attr('data-pre-order') === 'true';
        if (has_subscription === 1) {
          item.selling_plan = $(this).attr('data-selling-plan-id');
        }
        if (isPreOrder) {
          var preOrderMsg = $(this).attr('data-pre-order-message') || 'Pre-order';
          item.properties = { 'Pre-order': preOrderMsg };
        }
        items.push(item);
      });

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify({ items: items }),
        dataType: 'json',
        contentType: 'application/json',
        success: function(resp) {
          setBundleSourceAttribute(function() {
            if (has_subscription === 1) {
              reconcileCartFrequency(function() {
                btn.removeAttr('disabled').removeClass('disabled');
                btn.find('.loading__spinner').addClass('hidden');
                var drawer = document.querySelector('cart-drawer');
                if (drawer && drawer.fetchAndOpen) drawer.fetchAndOpen();
              });
            } else {
              btn.removeAttr('disabled').removeClass('disabled');
              btn.find('.loading__spinner').addClass('hidden');
              var drawer = document.querySelector('cart-drawer');
              if (drawer && drawer.fetchAndOpen) drawer.fetchAndOpen();
            }
          });
        },
        error: function(err) {
          btn.removeAttr('disabled').removeClass('disabled');
          btn.find('.loading__spinner').addClass('hidden');
          console.error('Bundle cart error:', err.responseText || err);
        }
      });
    }
  });

  // --- Buy once button ---
  $(document).delegate("#bundle_buy_once_button", "click", function(e) {
    e.preventDefault();
    if (!$(this).prop('disabled')) {
      var btn = $(this);
      btn.attr('disabled', 'disabled').addClass('disabled');
      btn.find('.loading__spinner').removeClass('hidden');
      var items = [];
      $('.bundle-product-list-items .bundle-product-list-item.item-active:not([data-sold-out])').each(function() {
        var item = {
          id: $(this).data('variant-id'),
          quantity: parseInt($(this).find('.bundle-qty-display').text())
        };
        if ($(this).attr('data-pre-order') === 'true') {
          var preOrderMsg = $(this).attr('data-pre-order-message') || 'Pre-order';
          item.properties = { 'Pre-order': preOrderMsg };
        }
        items.push(item);
      });

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify({ items: items }),
        dataType: 'json',
        contentType: 'application/json',
        success: function() {
          setBundleSourceAttribute(function() {
            btn.removeAttr('disabled').removeClass('disabled');
            btn.find('.loading__spinner').addClass('hidden');
            var drawer = document.querySelector('cart-drawer');
            if (drawer && drawer.fetchAndOpen) drawer.fetchAndOpen();
          });
        },
        error: function() {
          btn.removeAttr('disabled').removeClass('disabled');
          btn.find('.loading__spinner').addClass('hidden');
        }
      });
    }
  });

  // --- Notify Me popup (Klaviyo back-in-stock) ---
  $(document).delegate(".bundle-add-btn.is-notify", "click", function(e) {
    e.preventDefault();
    var $card = $(this).closest('.bundle-product-list-item');
    var productName = $card.find('.bundle-product-name').text().trim();
    var variantId = $(this).data('variant-id');
    var productHandle = $card.data('product-handle');
    $('#sb-notify-product-name').text(productName);
    $('#sb-notify-form').data('variant-id', variantId).data('product-handle', productHandle);
    $('#sb-notify-feedback').attr('hidden', true);
    $('#sb-notify-popup').removeAttr('hidden');
    $('#sb-notify-email').val('').focus();
  });

  // Close popup
  $(document).delegate(".sb-notify-popup__close, .sb-notify-popup__backdrop", "click", function() {
    $('#sb-notify-popup').attr('hidden', true);
  });
  $(document).on('keydown', function(e) {
    if (e.key === 'Escape' && !$('#sb-notify-popup').is('[hidden]')) {
      $('#sb-notify-popup').attr('hidden', true);
    }
  });

  // Submit to Klaviyo
  $(document).delegate("#sb-notify-form", "submit", function(e) {
    e.preventDefault();
    var email = $('#sb-notify-email').val();
    var variantId = $(this).data('variant-id');
    var $feedback = $('#sb-notify-feedback');
    var $btn = $(this).find('button[type="submit"]');
    $btn.prop('disabled', true).text('Sending...');

    var productName = $('#sb-notify-product-name').text();
    var productHandle = $('#sb-notify-form').data('product-handle');

    // Step 1: Subscribe email to list
    var subscribePromise = fetch('https://a.klaviyo.com/client/subscriptions/?company_id=SkxvMg', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-10-15'
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Bundle Builder - Back in Stock',
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: 'SxwLpF'
              }
            }
          }
        }
      })
    });

    // Step 2: Log event with product details (segmentable per flavor)
    var eventPromise = fetch('https://a.klaviyo.com/client/events/?company_id=SkxvMg', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-10-15'
      },
      body: JSON.stringify({
        data: {
          type: 'event',
          attributes: {
            metric: { data: { type: 'metric', attributes: { name: 'Back in Stock Request' } } },
            profile: { data: { type: 'profile', attributes: { email: email } } },
            properties: {
              'Product Name': productName,
              'Product Handle': productHandle,
              'Variant ID': variantId
            }
          }
        }
      })
    });

    Promise.all([subscribePromise, eventPromise])
    .then(function(responses) {
      var failed = responses.some(function(res) { return !res.ok; });
      if (failed) throw new Error('Request failed');
      $feedback.text("You're on the list! We'll notify you.").removeAttr('hidden').removeClass('is-error');
      $btn.prop('disabled', false).text('Notify Me');
      setTimeout(function() { $('#sb-notify-popup').attr('hidden', true); }, 2000);
    })
    .catch(function() {
      $feedback.text('Something went wrong. Try again.').removeAttr('hidden').addClass('is-error');
      $btn.prop('disabled', false).text('Notify Me');
    });
  });

  // ============================================================
  // Progress Bar
  // ============================================================

  function getTotalQuantity() {
    var total = 0;
    $('.bundle-product-list-items .bundle-product-list-item.item-active').each(function() {
      total += parseInt($(this).find('.bundle-qty-display').text()) || 0;
    });
    return total;
  }

  function getCurrentTier() {
    var totalQty = getTotalQuantity();
    var currentTier = null;
    $('.sb-tier-progress__step').each(function() {
      var bagCount = $(this).data('bag-count');
      if (totalQty >= bagCount) {
        currentTier = $(this);
      }
    });
    return currentTier;
  }

  function updateProgressBar() {
    var totalQty = getTotalQuantity();
    var steps = $('.sb-tier-progress__step');
    var totalSteps = steps.length;
    if (totalSteps === 0) return;

    // Reset all steps
    steps.removeClass('is-reached is-active');

    // Determine fill width and active states
    var fillPercent = 0;
    var activeIndex = -1;

    steps.each(function(index) {
      var bagCount = $(this).data('bag-count');
      if (totalQty >= bagCount) {
        $(this).addClass('is-reached');
        activeIndex = index;
      }
    });

    // Set active on the current tier
    if (activeIndex >= 0) {
      steps.eq(activeIndex).addClass('is-active');
    }

    // Calculate fill percentage (0% at first node, 100% at last node)
    if (activeIndex < 0) {
      fillPercent = 0;
    } else {
      fillPercent = (activeIndex / (totalSteps - 1)) * 100;
    }

    // Fill is handled by CSS — .is-reached class on steps turns their ::before brown
  }

  // ============================================================
  // Price Calculation
  // ============================================================

  function formatPrice(price) {
    if (typeof price === 'undefined') price = 0;
    var symbol = window.currencySymbol || '$';
    var code = window.currencyCode || 'USD';
    return (price / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: code
    });
  }

  function getActiveTierData() {
    var totalQty = getTotalQuantity();
    var tierData = {
      bagCount: 1,
      discount: 0,
      subscriptionDiscount: 0
    };

    // Default to first step values
    var firstStep = $('.sb-tier-progress__step').first();
    if (firstStep.length) {
      tierData.bagCount = firstStep.data('bag-count');
      tierData.discount = firstStep.data('discount');
      tierData.subscriptionDiscount = firstStep.data('subscription-discount');
    }

    // Find best tier based on total quantity
    $('.sb-tier-progress__step').each(function() {
      var bagCount = $(this).data('bag-count');
      if (totalQty >= bagCount) {
        tierData.bagCount = bagCount;
        tierData.discount = $(this).data('discount');
        tierData.subscriptionDiscount = $(this).data('subscription-discount');
      }
    });

    return tierData;
  }

  function updatePrice() {
    var tier = getActiveTierData();
    var buyOnceButton = $('#bundle_buy_once_button');
    var savingsPill = $('#sb_savings_pill');
    var btnPrices = $('#sb_btn_prices');
    var btnStrike = $('#sb_btn_strike');
    var btnSale = $('#sb_btn_sale');
    var has_subscription = $('.bundle-product-purchase-options .smartrr-otp.smartrr-group-inactive').length;
    var activeItems = $('.bundle-product-list-items .bundle-product-list-item.item-active');

    if (activeItems.length === 0) {
      // No items selected — show default pricing from first product
      var product = $('.bundle-product-list-items .bundle-product-list-item:first');
      var price = product.data('price');
      var compareAtPrice = product.data('compare-at-price');
      var recurringPrice = product.data('recurring-price');
      var discountedPrice = price - (price * tier.discount / 100);
      var discountedRecurringPrice = recurringPrice - (recurringPrice * tier.subscriptionDiscount / 100);

      $('.product .product__info-wrapper [data-smartrr-form-id] [data-smartrr-selling-plan-group-id]').each(function () {
        $(this).find('[data-smartrr-compare-price]').text(formatPrice(compareAtPrice)).removeClass('hidden');
        $(this).find('[data-smartrr-subscribe-price]').text(formatPrice(discountedRecurringPrice) + '/ea').removeClass('hidden');
        $(this).find('[data-smartrr-regular-price]').text(formatPrice(price)).removeClass('hidden');
        if ($(this).hasClass('smartrr-otp')) {
          $(this).find('[data-smartrr-subscribe-price]').text(formatPrice(discountedPrice) + '/ea');
          $(this).find('[data-smartrr-regular-price]').text(formatPrice(price));
        }
      });

      // Show default savings pill (1-bag tier)
      var defaultSavingsPercent = Math.round((price - discountedRecurringPrice) / price * 100);
      if (defaultSavingsPercent > 0) {
        savingsPill.text('SAVE ' + defaultSavingsPercent + '% ON FIRST ORDER').show();
        $('[data-benefits-pct]').text(defaultSavingsPercent);
      } else {
        savingsPill.hide();
      }
      btnPrices.addClass('hidden');
      buyOnceButton.addClass('hidden');
      buyOnceButton.find('.money').text(formatPrice(0));
      $('.free-gift-note').addClass('hidden');

    } else {
      // Items selected — calculate based on auto-detected tier
      var product = activeItems.first();
      var price = product.data('price');
      var compareAtPrice = product.data('compare-at-price');
      var recurringPrice = product.data('recurring-price');
      var discountedPrice = price - (price * tier.discount / 100);
      var discountedRecurringPrice = recurringPrice - (recurringPrice * tier.subscriptionDiscount / 100);

      $('.product .product__info-wrapper [data-smartrr-form-id] [data-smartrr-selling-plan-group-id]').each(function () {
        $(this).find('[data-smartrr-compare-price]').text(formatPrice(compareAtPrice)).removeClass('hidden');
        $(this).find('[data-smartrr-subscribe-price]').text(formatPrice(discountedRecurringPrice) + '/ea').removeClass('hidden');
        $(this).find('[data-smartrr-regular-price]').text(formatPrice(price)).removeClass('hidden');
        if ($(this).hasClass('smartrr-otp')) {
          $(this).find('[data-smartrr-subscribe-price]').text(formatPrice(discountedPrice) + '/ea');
          $(this).find('[data-smartrr-regular-price]').text(formatPrice(price));
        }
      });

      // Calculate totals
      var totalPrice = 0;
      var totalDiscountedPrice = 0;
      var totalDiscountedRecurringPrice = 0;

      activeItems.each(function() {
        var p = $(this).data('price');
        var rp = $(this).data('recurring-price');
        var dp = p - (p * tier.discount / 100);
        var drp = rp - (rp * tier.subscriptionDiscount / 100);
        var qty = parseInt($(this).find('.bundle-qty-display').text());
        totalPrice += p * qty;
        totalDiscountedPrice += dp * qty;
        totalDiscountedRecurringPrice += drp * qty;
      });

      // Savings pill + button prices
      if (has_subscription === 1) {
        var savingsPercent = Math.round((totalPrice - totalDiscountedRecurringPrice) / totalPrice * 100);
        if (savingsPercent > 0) {
          savingsPill.text('SAVE ' + savingsPercent + '% ON FIRST ORDER').show();
          $('[data-benefits-pct]').text(savingsPercent);
        } else {
          savingsPill.hide();
        }
        btnStrike.text(formatPrice(totalPrice));
        btnSale.text(formatPrice(totalDiscountedRecurringPrice));
        btnPrices.removeClass('hidden');
      } else {
        savingsPill.hide();
        if (totalDiscountedPrice < totalPrice) {
          btnStrike.text(formatPrice(totalPrice));
          btnSale.text(formatPrice(totalDiscountedPrice));
          btnPrices.removeClass('hidden');
        } else {
          btnPrices.addClass('hidden');
        }
      }

      buyOnceButton.removeClass('hidden');
      buyOnceButton.find('.money').text(formatPrice(totalDiscountedPrice));
      $('.free-gift-note').removeClass('hidden');

    }
  }

  // ============================================================
  // Tier Progress Bar Per-Bag Prices
  // ============================================================

  function updateTierPrices() {
    var product = $('.bundle-product-list-items .bundle-product-list-item:first');
    if (!product.length) return;
    var price = product.data('price');
    var recurringPrice = product.data('recurring-price');
    var has_subscription = $('.bundle-product-purchase-options .smartrr-otp.smartrr-group-inactive').length;

    $('.sb-tier-progress__step').each(function() {
      var subDiscount = $(this).data('subscription-discount');
      var onetimeDiscount = $(this).data('discount');
      var perBag;
      if (has_subscription === 1) {
        perBag = recurringPrice - (recurringPrice * subDiscount / 100);
      } else {
        perBag = price - (price * onetimeDiscount / 100);
      }
      // Price per cup label is set in the theme editor (static display)
    });
  }

  // ============================================================
  // Add to Cart Validation
  // ============================================================

  function updateAddToCart() {
    var totalQty = getTotalQuantity();
    var bundle_buy_button = $('#bundle_buy_button');
    var bundle_buy_once_button = $('#bundle_buy_once_button');
    var incentive = $('#bundle_incentive');

    if (totalQty === 0) {
      // No items — disabled
      bundle_buy_button.find('span').first().text('Add your flavors');
      bundle_buy_button.attr('disabled', 'disabled');
      bundle_buy_once_button.attr('disabled', 'disabled');
      incentive.addClass('hidden').text('');
    } else {
      // 1+ items — enabled
      bundle_buy_button.find('span').first().text('Add to cart');
      bundle_buy_button.removeAttr('disabled');
      bundle_buy_once_button.removeAttr('disabled');

      // Show incentive for next tier
      var nextTier = null;
      $('.sb-tier-progress__step').each(function() {
        var bagCount = $(this).data('bag-count');
        if (totalQty < bagCount && nextTier === null) {
          nextTier = {
            bagCount: bagCount,
            discount: $(this).data('discount')
          };
        }
      });

      if (nextTier) {
        var bagsNeeded = nextTier.bagCount - totalQty;
        var word = bagsNeeded === 1 ? 'bag' : 'bags';
        incentive.text('Add ' + bagsNeeded + ' more ' + word + ' to save ' + nextTier.discount + '%!');
        incentive.removeClass('hidden');
      } else {
        incentive.addClass('hidden').text('');
      }
    }
  }

  // ============================================================
  // Auto-set Subscription Frequency based on quantity
  // 1-2 bags → 30 days, 3-4 bags → 60 days, 5+ bags → 90 days
  // Selling plan: "Bundle Builder" (Loop Subscriptions)
  // ============================================================

  var FREQUENCY_PLAN_MAP = {
    '30': 4573528164,
    '60': 4573593700,
    '90': 4582408292
  };

  function getSellingPlanId(targetDays) {
    // Try select options first, fall back to hardcoded map
    var planId = null;
    var $select = $('#smartrr-plans-frequency-select');
    $select.find('option').each(function() {
      var freqText = ($(this).attr('data-selling-frequency-id') || $(this).text()).toString();
      if (freqText.indexOf(targetDays) !== -1) {
        planId = parseInt($(this).attr('data-selling-plan-id'));
        return false;
      }
    });
    if (!planId && FREQUENCY_PLAN_MAP[targetDays]) {
      planId = FREQUENCY_PLAN_MAP[targetDays];
    }
    return planId;
  }

  // ============================================================
  // Cart Frequency Reconciliation
  // After adding subscription items, check if the total bundle
  // quantity in cart crosses a tier threshold and update all
  // bundle line items to the correct selling plan frequency.
  // ============================================================

  function reconcileCartFrequency(callback) {
    // Collect bundle variant IDs from the page
    var bundleVariantIds = [];
    $('.bundle-product-list-items .bundle-product-list-item').each(function() {
      bundleVariantIds.push(parseInt($(this).attr('data-variant-id')));
    });

    $.getJSON('/cart.js', function(cart) {
      // Count total bundle subscription items in cart
      var totalBundleQty = 0;
      var bundleLineKeys = [];
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        if (bundleVariantIds.indexOf(item.variant_id) !== -1 && item.selling_plan_allocation) {
          totalBundleQty += item.quantity;
          bundleLineKeys.push({ key: item.key, currentPlanId: item.selling_plan_allocation.selling_plan.id });
        }
      }

      // Determine correct frequency for this total
      var targetDays;
      if (totalBundleQty <= 2) targetDays = '30';
      else if (totalBundleQty <= 4) targetDays = '60';
      else targetDays = '90';

      // Find the correct selling plan ID
      var correctPlanId = getSellingPlanId(targetDays);

      if (!correctPlanId || bundleLineKeys.length === 0) {
        callback();
        return;
      }

      // Check if any line items need updating
      var linesToUpdate = [];
      for (var j = 0; j < bundleLineKeys.length; j++) {
        if (bundleLineKeys[j].currentPlanId !== correctPlanId) {
          linesToUpdate.push(bundleLineKeys[j]);
        }
      }

      if (linesToUpdate.length === 0) {
        callback();
        return;
      }

      // Update each line item's selling plan sequentially
      var updateIndex = 0;
      function updateNext() {
        if (updateIndex >= linesToUpdate.length) {
          callback();
          return;
        }
        var line = linesToUpdate[updateIndex];
        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: JSON.stringify({ id: line.key, selling_plan: correctPlanId }),
          dataType: 'json',
          contentType: 'application/json',
          complete: function() {
            updateIndex++;
            updateNext();
          }
        });
      }
      updateNext();
    }).fail(function() {
      callback();
    });
  }

  function updateFrequency() {
    var $select = $('#smartrr-plans-frequency-select');
    if (!$select.length) return;

    var totalQty = getTotalQuantity();
    var targetDays;
    if (totalQty <= 2) {
      targetDays = '30';
    } else if (totalQty <= 4) {
      targetDays = '60';
    } else {
      targetDays = '90';
    }

    // Find the option whose frequency text contains the target days
    var $targetOption = null;
    $select.find('option').each(function() {
      var freqText = ($(this).attr('data-selling-frequency-id') || $(this).text()).toString();
      if (freqText.indexOf(targetDays) !== -1) {
        $targetOption = $(this);
        return false;
      }
    });

    // Get the correct plan ID (from select or fallback map)
    var newPlanId = getSellingPlanId(targetDays);

    if ($targetOption) {
      $select.val($targetOption.val());
    }

    if (newPlanId) {
      $('.bundle-product-list-items .bundle-product-list-item').each(function() {
        $(this).attr('data-selling-plan-id', newPlanId);
      });
    }

    // Update the visible frequency label
    var $label = $('[data-smartrr-selling-plan-pills-header]');
    if ($label.length) {
      var freqText;
      if ($targetOption) {
        freqText = ($targetOption.attr('data-selling-frequency-id') || $targetOption.text()).toString();
      } else {
        freqText = 'Deliver every ' + targetDays + ' days';
      }
      freqText = freqText.replace(/Deliver(ed)?\s+every\s+/i, '');
      $label.text('Every ' + freqText);
    }
  }

  // ============================================================
  // Delivery Date Estimate
  // ============================================================

  function updateDeliveryDate() {
    var $dateEl = $('.sb-delivery-info__date');
    if (!$dateEl.length) return;

    var now = new Date();
    var hour = now.getHours();
    var day = now.getDay(); // 0=Sun, 6=Sat

    // If it's after 2pm or weekend, shipping starts next business day
    var shipsDate = new Date(now);
    if (hour >= 14 || day === 0 || day === 6) {
      shipsDate.setDate(shipsDate.getDate() + 1);
    }
    // Advance to next Monday if landing on weekend
    while (shipsDate.getDay() === 0 || shipsDate.getDay() === 6) {
      shipsDate.setDate(shipsDate.getDate() + 1);
    }

    // Calculate delivery window: 2-5 business days from ship date
    function addBusinessDays(start, days) {
      var d = new Date(start);
      var added = 0;
      while (added < days) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() !== 0 && d.getDay() !== 6) {
          added++;
        }
      }
      return d;
    }

    var earliest = addBusinessDays(shipsDate, 2);
    var latest = addBusinessDays(shipsDate, 5);

    var opts = { month: 'short', day: 'numeric' };
    var earliestStr = earliest.toLocaleDateString('en-US', opts);
    var latestStr = latest.toLocaleDateString('en-US', opts);

    $dateEl.text('Delivered by ' + earliestStr + ' – ' + latestStr);
  }

  $(document).ready(function () {
    updateDeliveryDate();
  });

  // ============================================================
  // Sticky Footer
  // ============================================================

  $(document).ready(function () {
    const $sticky = $('.bundle_footer_wrapper');
    const $startEl = $('.bundle_content_wrapper');
    const $endEl = $('.bundle_content_wrapper');

    if (!$startEl.length || !$endEl.length || !$sticky.length) return;

    $(window).on('scroll', function () {
      const windowTop = $(window).scrollTop();
      const windowBottom = windowTop + $(window).height();
      const startOffset = $startEl.offset().top + 150;
      const endBottom = $endEl.offset().top + $endEl.outerHeight();

      if (windowBottom > startOffset && windowBottom < endBottom) {
        $sticky.addClass('is-sticky-active');
      } else {
        $sticky.removeClass('is-sticky-active');
      }
    }).trigger('scroll');
  });
})();
